export enum PROJECT_TYPE_CODE {
  CONTRACT = 'CTC',
  QUOTATION = 'QUT',
  ANTIPICATED_INVOICE = 'AIV',
  JOBSITE = 'JST',
}

export type ProjectTypeCodeType =
  | PROJECT_TYPE_CODE.CONTRACT
  | PROJECT_TYPE_CODE.QUOTATION
  | PROJECT_TYPE_CODE.ANTIPICATED_INVOICE
  | PROJECT_TYPE_CODE.JOBSITE;
